import { CompanyFilter } from "../../../../../../../legacy/types/companyFilter";
import { Market, Workspace } from "../../../../../../../types/workspace";
import { useConfigurationFilters } from "../../../../../hooks/useConfigurationFilters";

export const useCompetitorPresenceFilters = (
  workspace: Workspace | undefined,
  selectedMarket: Market
): CompanyFilter => {
  const filters = useConfigurationFilters(workspace, selectedMarket);

  return {
    ...filters,
    products: [
      ...(filters?.products || []),
      {
        ids: workspace?.configuration.competitorsProductIds ?? [],
        inclusionMethod: "ANY_PRESENT",
      },
    ],
  };
};
